import React, { useState, useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { is1024andSmaller } from 'swag-client-common/utils/ui.utils';
import { getS3NameByFilename } from 'swag-common/services/links/get-download-link-from-s3.service';
import poster from 'assets/img/backgrounds/video-poster.png';
import xMark from 'assets/img/x-mark.png';
import Loading from '../info/loading';
import css from './video-popup.scss';
import anim from './anim-pre-video-wrapper.scss';
const videoName = 'what-we-do-4';
const VideoPopupContent = ({
  onCloseVideoPopup,
  playedFromUrl
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const isMobileView = is1024andSmaller();
  const videoRef = useRef(null);
  const videoTag = videoRef.current;
  const onOverlayClick = e => {
    if (e.target.hasAttribute('data-overlay')) {
      onCloseVideoPopup();
    }
  };
  useEffect(() => {
    if (videoTag) {
      // @todo. auto generated. fix this error
      // @ts-ignore
      videoTag.focus();
    }
  }, [videoTag]);
  return /*#__PURE__*/React.createElement("div", {
    className: css.fakeOverlay,
    onClick: onOverlayClick,
    "data-overlay": true
  }, /*#__PURE__*/React.createElement("div", {
    className: css.videoPopupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css.popupContent
  }, !playedFromUrl && /*#__PURE__*/React.createElement(CSSTransition, {
    in: isLoading,
    timeout: 1000,
    classNames: anim,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Loading, {
    hasOverlay: false,
    size: isMobileView ? 50 : 117
  })), /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    controls: true,
    className: css.video,
    disablePictureInPicture: true,
    controlsList: "nodownload",
    autoPlay: !playedFromUrl,
    preload: "auto"
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    poster: isMobileView && poster,
    onPlay: () => !playedFromUrl && setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: getS3NameByFilename(`videos/${videoName}.webm`),
    type: "video/webm"
  }), /*#__PURE__*/React.createElement("source", {
    src: getS3NameByFilename(`videos/${videoName}.mp4`),
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("source", {
    src: getS3NameByFilename(`videos/${videoName}.ogv`),
    type: "video/ogg"
  })))), /*#__PURE__*/React.createElement("span", {
    onClick: onCloseVideoPopup,
    className: css.closeBtn
  }, /*#__PURE__*/React.createElement("img", {
    src: xMark,
    className: css.closeBtnImg,
    alt: "close video popup"
  })));
};
export default VideoPopupContent;